// Hero Video
(function($) {

    var heroMp4File = $('#hero-mp4-file'),
        heroWebmFile = $('#hero-webm-file'),
        heroVideoContainer = $('#hero-video-container');
		heroOverlay = $('.hero-overlay'),
		section = heroOverlay.parents('.image-block');

    if (heroVideoContainer.length && $(window).width() > 768) {

        var heroVideoObject = document.createElement("video");

        $('.bg-img').addClass('d-none');

        $(heroVideoObject).addClass('hero-video');

        if (heroMp4File.length) {
            var sourceMP4 = document.createElement("source");
            sourceMP4.type = "video/mp4;";
            sourceMP4.src = heroMp4File.val();
            heroVideoObject.appendChild(sourceMP4);
        }

        if (heroWebmFile.length) {
            var sourceWebM = document.createElement("source");
            sourceWebM.type = "video/webm";
            sourceWebM.src = heroWebmFile.val();
            heroVideoObject.appendChild(sourceWebM);
        }

        heroVideoObject.autoplay = true;
        heroVideoObject.muted = true;
        heroVideoObject.loop = true;
        heroVideoObject.playsinline = true;
        heroVideoObject.load();

        var playPromise = heroVideoObject.play();

        if (playPromise !== undefined) {
            playPromise.then(function () {
                // Automatic playback started!
            }).catch(function (error) {
                // Automatic playback failed.
                // Show a UI element to let the user manually start playback.
            });
		}

		heroVideoContainer.append(heroVideoObject);

		// Wait for video dimensions to be available
		heroVideoObject.addEventListener('loadedmetadata', function() {
			section.height($('.hero-video').height());
		});

        heroOverlay.addClass('hiding');
        setTimeout(function () {
            heroOverlay.addClass('d-none');
            $('.bg-img').removeClass('d-none');
		}, 1010);

	}

    if($('.hero-content-overlay h1').length) {
        $('.hero-content-overlay h1').html(function() {	
            // separate the text by spaces
            var text= $(this).text().split(' ');
            // drop the last word and store it in a variable
            var last = text.pop();
            // join the text back and if it has more than 1 word add the span tag
            // to the last word
            return text.join(" ") + (text.length > 0 ? ' <span class="color-green">'+last+'</span>' : last);   
        });
    
            
    }

	$(window).on('resize', function() {
		var heroVideo = $('.hero-video');

		if(heroVideo.length) {
			var section = heroVideo.parents('.image-block');
			section.height(heroVideo.height());
		}
	});

    function campNotice() {

        var modal = $('#camp-notice-modal'),
            version = modal.data('version');

        setTimeout(function () {
            $('#camp-notice-modal').modal('show');
        }, 2000);

        // if(Cookies.get('camp-notice-' + version)) {
        //     console.log('already displayed');
        // } else {
        //
        //     setTimeout(function () {
        //         $('#camp-notice-modal').modal('show');
        //     }, 2000);
        //
        //     Cookies.set('camp-notice-' + version, 'true', { expires: 30 });
        //
        // }

    }

    if($("#camp-notice-modal").length) campNotice();

}(jQuery));